<template>
  <div>
    <div v-if="isBigScreen" class="text-center d-flex flex-column">
      <v-btn-toggle
        v-model="selectedItem"
        class="toggleBtns toggleBtnBorder"
        rounded
      >
        <v-tooltip
          bottom
          v-for="(item, index) in optionKeys"
          :key="index"
          open-delay="300"
          class="URAtool"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="!optionsInSet.includes(item)"
              :class="[
                index == selectedItem ? 'activeBtn' : '',
                !optionsInSet.includes(item) ? 'disabledText' : '',
              ]"
              small
              outlined
              class="toggleBtns toggleBtnBorder"
              active-class="orangeActive"
              @click="selectedItem = index"
              v-bind="attrs"
              v-on="on"
            >
              <div v-if="index == 0" style="color: #a7682c">All</div>
              <v-img
                v-else
                :src="imageUrl(index)"
                height="19"
                width="19"
                :style="
                  [2, 3, 4, 6, 7].includes(index) ? 'margin-bottom:2px' : null
                "
                contain
              />
              <!-- {{ imageUrl(index) }} -->
            </v-btn>
          </template>
          <span v-text="labelText(index)"></span>
        </v-tooltip>
      </v-btn-toggle>
      <div class="caption">
        {{ labelText(selectedItem) }}
        <span
          v-if="selectedObj == 'DISPOSABLES'"
          class="caption"
          v-html="longText(selectedItem)"
        >
        </span>
      </div>
    </div>
    <div v-else>
      <v-btn
        @click="dialog = true"
        class="py-1 pr-1 btnClass"
        depressed
        solo
        outlined
        small
        rounded
      >
        <img
          :src="imageUrl(selectedItem)"
          height="21"
          width="21"
          class="mx-2 mb-1"
        />
        <!-- grey--text text--darken-2 -->
        <span class="px-2 textWidth"> {{ labelText(selectedItem) }}</span>

        <v-icon small class="ml-1" color="primary">mdi-menu-down</v-icon>
      </v-btn>

      <v-dialog
        v-model="dialog"
        max-width="98%"
        width="350"
        :transition="false"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2 d-flex flex-row">
            <div>Filter Replacements</div>
            <v-spacer></v-spacer>
            <v-btn icon color="primary" @click="dialog = false">
              <v-icon color="primary">mdi-close</v-icon></v-btn
            >
          </v-card-title>
          <v-card-text>
            <!-- {{ optionsInSet }} -->
            <v-list hover>
              <v-list-item-group v-model="selectedItem" color="primary">
                <v-list-item
                  v-for="(item, index) in optionKeys"
                  :key="index"
                  :disabled="!optionsInSet.includes(item)"
                >
                  <v-list-item-icon>
                    <img
                      :src="imageUrl(index)"
                      height="23"
                      width="23"
                      class="mr-3"
                    />
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title
                      :class="[
                        index != selectedItem ? 'grayText' : '',
                        !optionsInSet.includes(item) ? 'disabledText' : '',
                      ]"
                    >
                      <span v-text="labelText(index)"></span
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-if="item == 'DISPOSABLES'"
                      class="caption"
                      v-html="disposableDescription"
                    >
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="!optionsInSet.includes(item)">
                      (no lenses)
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
// * note : this holds on object that contains all the labels and images used above
import FilterDictionary from "@/assets/js/cls/FilterDictionary";

export default {
  name: "ReplaceSelect",
  props: {
    external: {
      type: String,
      default: "ALL",
    },
    canBeBig: {
      type: Boolean,
      default: false,
    },
    options: null,
  },
  data: function () {
    return {
      r: 1,
      imagePath: "/images/icons/replace/",
      selectedItem: 0,
      dialog: false,
      disposableDescription: "  Daily, Weekly, 2 Week &amp; Monthly",
    };
  },
  computed: {
    isBigScreen: function () {
      return this.canBeBig && this.$vuetify.breakpoint.mdAndUp;
    },
    optionKeys: function () {
      return Object.keys(FilterDictionary.filterOptions.replace);
    },
    selectedObj: function () {
      return this.optionKeys[this.selectedItem];
    },
    optionsInSet: function () {
      let keys = this.optionKeys;
      if (!this.options) return keys;
      let options = this.options;
      // console.log("this.options", this.options);

      let rtn = [];
      keys.forEach((key) => {
        let arr4key = FilterDictionary.filterOptions.replace[key].days;
        // console.log(key, arr4key);
        if (!arr4key) {
          rtn.push(key);
        } else {
          let include = false;
          options.forEach((days) => {
            if (arr4key.includes(days)) include = true;
          });
          if (include) rtn.push(key);

          // console.log("include? ", include);
        }
      });
      // console.log(rtn);
      return rtn;
    },
  },
  methods: {
    // convenience function - takes an index from the optionKeys array and finds the key
    replaceObjForIndex(index) {
      let key = this.optionKeys[index];
      return this.replaceObjForKey(key);
    },
    // uses a key and gets a lens type object from FilterDictionary.lensTypeOptions object
    replaceObjForKey(key) {
      return FilterDictionary.filterOptions.replace[key];
    },
    labelText(index) {
      let obj = this.replaceObjForIndex(index);
      //console.log(obj);
      return obj.label;
    },
    shortText(index) {
      let obj = this.replaceObjForIndex(index);
      //console.log(obj);
      return obj.shortText;
    },
    longText(index) {
      let obj = this.replaceObjForIndex(index);
      return obj.longText ? `(${obj.longText})` : "";
    },
    imageUrl(index) {
      let itemForIndex = this.replaceObjForIndex(index);
      let file = itemForIndex.image;
      let url = this.imagePath + file;
      let key = this.optionKeys[index];
      url += this.optionsInSet.includes(key) ? "_active" : "";
      url += ".svg";
      return url;
    },
    setSelectedItemForKey(key) {
      if (!key) {
        this.selectedItem = 0;
        return;
      }
      let index = this.optionKeys.indexOf(key.toUpperCase());
      if (index != this.selectedItem) this.selectedItem = index;
    },
  },

  watch: {
    selectedItem(index) {
      this.dialog = false;
      let val = this.optionKeys[index];
      this.$store.dispatch("setFilterValue", { key: "replace", value: val }); // todo - remove this?
      // console.log("emiting ", val);
      this.$emit("replace", val);
      this.$emit("image", this.imageUrl(this.selectedItem));
    },
    external(val) {
      // for when the val is set externally by the prop
      this.setSelectedItemForKey(val);
    },
  },

  mounted: function () {
    // console.log("mounting replaceSelector: " + this.external);
    this.setSelectedItemForKey(this.external);
  },
};
</script>

<style scoped>
.grayText {
  color: #383838;
}
.disabledText {
  color: rgb(150, 150, 150);
}
.grayBorder.v-btn {
  border: thn solid #636363;
}
.fb-btn.v-btn--outlined {
  border: thin solid #cccccc;
}
.activeBtn {
  background-color: pink;
  color: pink;
}
.pointer {
  cursor: pointer;
}
.littleText {
  font-size: 8pt;
}
.btnClass {
  background-color: #ffffff80;
  border: thin solid #b6b6b6;
}
.textWidth {
  min-width: 155px;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: #b06a28 !important;
}
</style>
